import {Flex, Radio} from 'antd';
import {TILT_WARNING_INITIAL_POSITIONS} from '../../../../Shared/Constants/TiltWarning/TiltWarning';
import React from 'react';

interface TiltWarningInitialPositionSelectProps {
	value: {reference_x: number; reference_y: number; reference_z: number};
	disabled: boolean;
}

export default function TiltWarningInitialPositionSelectComponent(props: Readonly<TiltWarningInitialPositionSelectProps>) {
	const selectedPosition = Object.values(TILT_WARNING_INITIAL_POSITIONS).find(
		v =>
			props.value &&
			v.reference_x === props.value.reference_x &&
			v.reference_y === props.value.reference_y &&
			v.reference_z === props.value.reference_z
	);

	return (
		<div>
			<label htmlFor="selectTiltWarning">Mounting position</label>
			<div id="selectTiltWarning">
				<Radio.Group
					name="tiltWarningPosition"
					value={selectedPosition?.id}
					disabled={props.disabled}
					style={{display: 'flex', flexWrap: 'wrap', gap: '16px'}}
					options={Object.values(TILT_WARNING_INITIAL_POSITIONS).map(v => ({
						value: v.id,
						label: (
							<Flex gap="small" justify="center" align="center" vertical>
								<img src={`/img/TiltWarning${v.name}.svg`} alt={v.name} style={{width: '100px', height: '100px'}} />
								<span>{v.name}</span>
							</Flex>
						),
					}))}
				/>
			</div>
		</div>
	);
}
